<template>
<div id="app" >

  <Header v-if="this.$route.meta.auth && this.$route.meta.head"></Header>
  <router-view ></router-view>
  <cookie-law  buttonText="Понятно"><div slot="message">
    Мы используем Куки
  </div></cookie-law>

  

  
</div>
</template>
<script>

import Header from './core/Header.vue'
import CookieLaw from 'vue-cookie-law'


export default {
  name: 'App',
  components: {
    
    Header, 
    CookieLaw

  },
  mounted() {
     if (location.protocol !== 'https:') {
       location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }

    
  }
}
</script>

<style lang="scss">
.bm-overlay
{
  background: transparent !important;
}
.bm-item-list
{
  width: 290px !important;
  margin-left: 10px !important;
  font-size: 14px !important;
}
.bm-item-list>*>span{
  margin-left: 0px !important;
}
.Cookie--base .Cookie__button
{
  background: #08a2dc !important;
}
$blue: #08a2dc;
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';
</style>
